import { cx } from '../../utils/cx';
import { LinkButton, type LinkButtonProps } from '../link_button/link_button';

import styles from './empty_state.module.css';

export type EmptyStateActionLinkProps = Omit<LinkButtonProps, 'className'> & {
  className?: string;
};

/**
 * EmptyStateActionLink - action sub-component for empty states that navigate.
 * See `EmptyStateActionButton` for an action that does something else.
 */
export const EmptyStateActionLink = ({
  className,
  children,
  ...rest
}: EmptyStateActionLinkProps) => {
  return (
    <LinkButton
      className={cx([styles.action, className])}
      variant="secondary"
      {...rest}
    >
      {children}
    </LinkButton>
  );
};
